
import "../Foundation/stylable/colors.st.css.js";

import "../common/styles/visuallyHidden.st.css.js";
import "../common/styles/visuallyHidden.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_139_1_AngleInput";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_139_1_AngleInput__root","visuallyHidden":"wds_1_139_1_visuallyHidden__visuallyHidden","track":"wds_1_139_1_AngleInput__track","arm":"wds_1_139_1_AngleInput__arm","knob":"wds_1_139_1_AngleInput__knob","knobWrapper":"wds_1_139_1_AngleInput__knobWrapper","visuallyHiddenInput":"wds_1_139_1_AngleInput__visuallyHiddenInput wds_1_139_1_visuallyHidden__visuallyHidden"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"wrapperWidth":"58px","trackDiameter":"48px","armWidth":"2px","knobWrapperWidth":"18px","knobRegularWidth":"4px","knobLargeWidth":"12px","knobRegularBorderWidth":"4px","knobLargeBorderWidth":"3px","knobWrapperCenter":"calc(18px / 2)","trackRadius":"calc(var(--wds-space-800, 48px) / 2)"}; 
export var vars = {"wds-color-fill-standard-primary":"--wds-color-fill-standard-primary","wds-color-border-standard-secondary":"--wds-color-border-standard-secondary","wds-color-border-standard-secondary-disabled":"--wds-color-border-standard-secondary-disabled","wds-color-fill-standard-primary-disabled":"--wds-color-fill-standard-primary-disabled","wds-space-800":"--wds-space-800","wds-angle-input-value":"--wds-angle-input-value"}; 




